/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Security8021XCertificateInfoFragment = {
	issuer: string | null;
	validFromDate: string;
	expirationDate: string;
	hash: string | null;
};

export type Security8021XDeviceSettingsFragment = {
	id: string;
	status: Types.DeviceStatus;
	description: { model: string; features: { security8021X: { supported: boolean } } };
	features: {
		security8021X: {
			enabled: boolean;
			eapMethod: Types.EapMethod8021X;
			rebootRequired: boolean;
			username: string | null;
			anonymousId: string | null;
			lastAuthenticationStatus: Types.LastAuthenticationStatus8021X;
			rootCertificate: Security8021XCertificateInfoFragment | null;
			clientCertificate: Security8021XCertificateInfoFragment | null;
		} | null;
		authentication: {
			credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
		} | null;
	};
};

export type Security8021XSettingsDeviceUpdateFragment = {
	id: string;
	features:
		| {
				authentication: {
					credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
				} | null;
		  }
		| {
				security8021X: {
					anonymousId: string | null;
					eapMethod: Types.EapMethod8021X;
					enabled: boolean;
					lastAuthenticationStatus: Types.LastAuthenticationStatus8021X;
					rebootRequired: boolean;
					username: string | null;
					clientCertificate: {
						expirationDate: string;
						hash: string | null;
						issuer: string | null;
						validFromDate: string;
					} | null;
					rootCertificate: {
						issuer: string | null;
						expirationDate: string;
						validFromDate: string;
						hash: string | null;
					} | null;
				} | null;
		  }
		| {};
};

export type Security8021XSettingsDeviceQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
}>;

export type Security8021XSettingsDeviceQueryOpResult = { node: Security8021XDeviceSettingsFragment | {} };

export type Set8021XConfigMutationVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	config: Types.ConfigInput8021X;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type Set8021XConfigMutationOpResult = {
	configure8021x: {
		device: Security8021XDeviceSettingsFragment | null;
		error: { code: Types.ErrorCode; message: string } | null;
	};
};

export type ValidateCertificate8021XMutationVariables = Types.Exact<{
	certificate: Types.Scalars['String']['input'];
}>;

export type ValidateCertificate8021XMutationOpResult = {
	validateCertificate8021X: {
		error: { code: Types.ErrorCode; message: string } | null;
		certificateInfo: Security8021XCertificateInfoFragment | null;
	};
};

export type Set8021XEnabledMutationVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	enable: Types.Scalars['Boolean']['input'];
	rebootNow: Types.Scalars['Boolean']['input'];
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type Set8021XEnabledMutationOpResult = {
	enable8021x: {
		device: Security8021XDeviceSettingsFragment | null;
		error: { code: Types.ErrorCode; message: string } | null;
	};
};

export type Reset8021XMutationVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	rebootNow: Types.Scalars['Boolean']['input'];
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type Reset8021XMutationOpResult = { reset8021x: { error: { code: Types.ErrorCode; message: string } | null } };

export type RebootDeviceMutationVariables = Types.Exact<{
	rebootDeviceId: Types.Scalars['ID']['input'];
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type RebootDeviceMutationOpResult = {
	rebootDevice: { error: { code: Types.ErrorCode; message: string } | null };
};

export type Security8021XSettingsDeviceSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type Security8021XSettingsDeviceSubscriptionOpResult = {
	nodeChanges: Security8021XDeviceSettingsFragment | Security8021XSettingsDeviceUpdateFragment | {};
};

export const Security8021XCertificateInfoFragment = gql`
	fragment Security8021XCertificateInfoFragment on CertificateInfo8021X {
		issuer
		validFromDate
		expirationDate
		hash
	}
`;
export const Security8021XDeviceSettingsFragment = gql`
	fragment Security8021XDeviceSettingsFragment on Device {
		id
		status
		description {
			model
			features {
				security8021X {
					supported
				}
			}
		}
		features {
			security8021X {
				enabled
				eapMethod
				rebootRequired
				username
				rootCertificate {
					...Security8021XCertificateInfoFragment
				}
				clientCertificate {
					...Security8021XCertificateInfoFragment
				}
				anonymousId
				lastAuthenticationStatus
			}
			authentication {
				credentials {
					accessLevel
					credentialsState
				}
			}
		}
	}
	${Security8021XCertificateInfoFragment}
`;
export const Security8021XSettingsDeviceUpdateFragment = gql`
	fragment Security8021XSettingsDeviceUpdateFragment on DeviceChange {
		id
		features {
			... on DeviceSecurity8021XChange {
				security8021X {
					anonymousId
					clientCertificate {
						expirationDate
						hash
						issuer
						validFromDate
					}
					eapMethod
					enabled
					lastAuthenticationStatus
					rebootRequired
					rootCertificate {
						issuer
						expirationDate
						validFromDate
						hash
					}
					username
				}
			}
			... on DeviceAuthenticationChange {
				authentication {
					credentials {
						accessLevel
						credentialsState
					}
				}
			}
		}
	}
`;
export const Security8021XSettingsDeviceQueryDocument = gql`
	query Security8021XSettingsDeviceQuery($nodeId: ID!) {
		node(id: $nodeId) {
			... on Device {
				...Security8021XDeviceSettingsFragment
			}
		}
	}
	${Security8021XDeviceSettingsFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class Security8021XSettingsDeviceQueryGQL extends Apollo.Query<
	Security8021XSettingsDeviceQueryOpResult,
	Security8021XSettingsDeviceQueryVariables
> {
	override document = Security8021XSettingsDeviceQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const Set8021XConfigMutationDocument = gql`
	mutation Set8021XConfigMutation($nodeId: ID!, $config: ConfigInput8021X!, $injectKeyring: String) {
		configure8021x(id: $nodeId, config: $config, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				device {
					...Security8021XDeviceSettingsFragment
				}
			}
			error {
				code
				message
			}
		}
	}
	${Security8021XDeviceSettingsFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class Set8021XConfigMutationGQL extends Apollo.Mutation<
	Set8021XConfigMutationOpResult,
	Set8021XConfigMutationVariables
> {
	override document = Set8021XConfigMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ValidateCertificate8021XMutationDocument = gql`
	mutation ValidateCertificate8021XMutation($certificate: String!) {
		validateCertificate8021X(certificate: $certificate) {
			error {
				code
				message
			}
			certificateInfo {
				...Security8021XCertificateInfoFragment
			}
		}
	}
	${Security8021XCertificateInfoFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ValidateCertificate8021XMutationGQL extends Apollo.Mutation<
	ValidateCertificate8021XMutationOpResult,
	ValidateCertificate8021XMutationVariables
> {
	override document = ValidateCertificate8021XMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const Set8021XEnabledMutationDocument = gql`
	mutation Set8021XEnabledMutation($nodeId: ID!, $enable: Boolean!, $rebootNow: Boolean!, $injectKeyring: String) {
		enable8021x(id: $nodeId, enable: $enable, rebootNow: $rebootNow, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				device {
					...Security8021XDeviceSettingsFragment
				}
			}
			error {
				code
				message
			}
		}
	}
	${Security8021XDeviceSettingsFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class Set8021XEnabledMutationGQL extends Apollo.Mutation<
	Set8021XEnabledMutationOpResult,
	Set8021XEnabledMutationVariables
> {
	override document = Set8021XEnabledMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const Reset8021XMutationDocument = gql`
	mutation Reset8021XMutation($nodeId: ID!, $rebootNow: Boolean!, $injectKeyring: String) {
		reset8021x(id: $nodeId, rebootNow: $rebootNow, keyring: $injectKeyring) {
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class Reset8021XMutationGQL extends Apollo.Mutation<Reset8021XMutationOpResult, Reset8021XMutationVariables> {
	override document = Reset8021XMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const RebootDeviceMutationDocument = gql`
	mutation RebootDeviceMutation($rebootDeviceId: ID!, $injectKeyring: String) {
		rebootDevice(id: $rebootDeviceId, keyring: $injectKeyring) {
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class RebootDeviceMutationGQL extends Apollo.Mutation<
	RebootDeviceMutationOpResult,
	RebootDeviceMutationVariables
> {
	override document = RebootDeviceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const Security8021XSettingsDeviceSubscriptionDocument = gql`
	subscription Security8021XSettingsDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...Security8021XDeviceSettingsFragment
			...Security8021XSettingsDeviceUpdateFragment
		}
	}
	${Security8021XDeviceSettingsFragment}
	${Security8021XSettingsDeviceUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class Security8021XSettingsDeviceSubscriptionGQL extends Apollo.Subscription<
	Security8021XSettingsDeviceSubscriptionOpResult,
	Security8021XSettingsDeviceSubscriptionVariables
> {
	override document = Security8021XSettingsDeviceSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
